import { IFetchDirectivesDTO } from 'modules/customer/domain/dtos';
import { IPaymentDirectivesRepository } from 'shared/domain/repositories';

export class FetchDirectivesUseCase {
  constructor(
    private paymentDirectivesRepository: IPaymentDirectivesRepository,
  ) {}

  public async execute({ unitId }: IFetchDirectivesDTO) {
    return this.paymentDirectivesRepository.findByUnit({
      process: 'CARD_CHANGE',
      unitId,
    });
  }
}
